import { useFirebase } from "containers/FirebaseContext";
import {
    doc as firestoreDoc,
    getDoc,
    setDoc,
    updateDoc
} from "firebase/firestore";
import * as Sentry from '@sentry/react';

export const useResourceViews = () => {
    const { firestore } = useFirebase();
    const createResourceViews = async (ResourceData) => {
        try {
            const generated_view_id = ResourceData?.id;
            const docRef = firestoreDoc(
                firestore,
                "most_viewed_video",
                generated_view_id
            );
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                await updateDoc(docRef, ResourceData);
            } else {
                await setDoc(docRef, ResourceData);
            }
            return;
        } catch (error) {
            Sentry.captureException(`657 Error in createResourceViews: ${error}`);
            console.log(error, "error");
        }
    };
    
    return { createResourceViews };
};
